export enum TimeSheetStatusTextEnum {
	// time sheet has not been started by pilot (though there may be imported flights from CMS)
	NotStarted = 'Not Started',

	// has been submitted by pilot for approval by admin
	SubmittedByEmployee = 'Awaiting Approval',

	// has been approved by the admin and is ready to be exported
	ApprovedByAdmin = 'Approved',

	// has been exported to workday
	Paid = 'Paid',

	// has been started
	InProgress = 'In Progress'
}
